<template>
  <v-data-table
    :headers="headers"
    :items="elencoAccessi"
    item-key="_id"
    sort-by="tipo"
    class="elevation-1"
    :dense="isDense"
  >
    <template v-slot:[`item.data`]="{ item }">
      {{ item.data | dateTime }}
    </template>
    <template v-slot:[`item.causale`]="{ item }">
      {{ item.causale === 'accessi_entrata' ? 'entrata' : 'uscita' }}
    </template>    
    
    <template v-slot:no-data>
      Nessun accesso effettuato
    </template>
  </v-data-table>
</template>

<script>
  import _ from 'lodash'
  import movimenti from '@/services/movimentiService.js'

  /* eslint-disable */
  export default {
    props: {
      idCliente: String,
      idCard: String,
      isDense: { type: Boolean, default: true }
    },
    data: () => ({
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: 'Registrazione',
          align: 'start',
          sortable: false,
          value: '_id',
          width: '15%'
        },
        { text: 'Data', value: 'data', width: '15%' },
        { text: 'Tipo', value: 'causale',width: '15%' },
        { text: '', width: '55%'}
      ],
      elencoAccessi: []
    }),
    async created() {     
    },
    async mounted() {
      const elencoEntrate = await movimenti.getMovimentiPerRiferimento('accessi_entrata', this.idCard)
      const elencoUscite = await movimenti.getMovimentiPerRiferimento('accessi_uscita', this.idCard)
      this.elencoAccessi = (_.sortBy(elencoEntrate.concat(elencoUscite), ['data'])).reverse()
    },
    computed: {
    },
    watch: {
    },
    methods: {
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
  
  td.clientiSelected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }
</style>
